import { connect } from "react-redux";
import TagApprovalList from "./tagApprovalList";
import { bindActionCreators } from "redux";
import { getTagMismatchApprovalList, acceptApproval, rejectApproval } from "services/redux/approvals/salesApprovals/action"
import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  approvalList: state.salesApprovalReducer.tagApprovalList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getTagMismatchApprovalList,
  acceptApproval,
  rejectApproval,
  fetchZones,
  getListFilterData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagApprovalList);
